/**
 * App Config File
 */
import {config} from './index';

const AppConfig = {
    brandName: config.app.name, // Brand Name TODO: refactor and change usages to config.app.name
    navCollapsed: false, // Sidebar collapse
    darkMode: false, // Dark Mode
    boxLayout: false, // Box Layout
    rtlLayout: false, // RTL Layout
    miniSidebar: false, // Mini Sidebar
    enableSidebarBackgroundImage: true, // Enable Sidebar Background Image
    sidebarImage: require('../assets/img/sidebar-1.jpg'), // Select sidebar image
    isDarkSidenav: true, // Set true to dark sidebar
    enableThemeOptions: false, // process.env.NODE_ENV !== 'production', // Enable Theme Options
    locale: {
        languageId: 'english',
        locale: 'en',
        name: 'English',
        icon: 'en',
    },
    enableUserTour: true, // process.env.NODE_ENV === 'production', // Enable / Disable User Tour //TODO investigate
    // enableUserTour: true,
    copyRightText: 'ScanDocFlow © 2019-2026 All Rights Reserved.', // Copy Right Text
    // light theme colors
    themeColors: {
        primary: '#5D92F4',
        secondary: '#677080',
        success: '#00D014',
        danger: '#FF3739',
        warning: '#FFB70F',
        info: '#00D0BD',
        dark: '#464D69',
        default: '#FAFAFA',
        greyLighten: '#A5A7B2',
        grey: '#677080',
        white: '#FFFFFF',
        purple: '#896BD6',
        yellow: '#D46B08',
    },
    // dark theme colors
    darkThemeColors: {
        darkBgColor: '#424242',
    },
};

export default AppConfig;
